import { useMemo } from 'react';

type UseVehicleDisplayDataParams = {
  year?: number;
  make?: string;
  model?: string;
  vehicleValue?: number;
};

type VehicleDisplayData = {
  yearMakeModel: string;
  formattedValue: string;
};

/**
 * Custom hook to calculate display-related data for vehicle information.
 * Handles formatting of vehicle name and value.
 */
export const useVehicleDisplayData = ({
  year,
  make,
  model,
  vehicleValue
}: UseVehicleDisplayDataParams): VehicleDisplayData =>
  useMemo(() => {
    // Format year/make/model string
    const yearMakeModel = [year, make, model]
      .filter(val => val !== undefined && val !== null && val !== '')
      .join(' ');

    // Format vehicle value as currency
    const formattedValue = `$${vehicleValue?.toLocaleString() || '0'}`;

    return {
      yearMakeModel,
      formattedValue
    };
  }, [year, make, model, vehicleValue]);
